module.exports = __webpack_public_path__ + "img/medecin_1.515f1661.png";